import { createSlice } from "@reduxjs/toolkit";
import { FilterMatchMode } from "primereact/api";
import { cloneDeep } from "lodash";


const filter = {
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    isEnabled: { value: [true, false], matchMode: FilterMatchMode.IN },
    isArchived: { value: [false, null], matchMode: FilterMatchMode.IN }
}

const filterSlice = createSlice({
    name: 'filters',
    initialState: {
        initialFilters: cloneDeep(filter),
        currentFilters: cloneDeep(filter),
        partnerLevelFilters: {
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        }
    },

    reducers: {
        setFilters: (state, action) => {
            state.currentFilters = action.payload
        },
        setPartnerLevelFilters: (state, action) => {
            state.currentFilters = action.payload
        },
    },
});

export const { setFilters, setPartnerLevelFilters } = filterSlice.actions;
export default filterSlice.reducer;

